import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { CountryCode } from 'frontend-utils/utils/countries';
import type { Day } from 'lumen/models';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

export default class Holiday extends Model {
  [Type] = 'holiday' as const;

  @hasMany('day', { async: false, inverse: 'holidays' })
  declare days: HasMany<Day>;

  @attr() declare countries: Lowercase<CountryCode>[];
  @attr('dayjs') declare createdTimestamp: DayjsTransformReturn;
  @attr('hoteldate') declare endDate: NonNullable<HoteldateTransformReturn>;
  @attr('dayjs') declare lastUpdateTimestamp: DayjsTransformReturn;
  @attr('string') declare name: string;
  @attr('hoteldate') declare startDate: NonNullable<HoteldateTransformReturn>;

  get hasMoreThanTwoCountries(): boolean {
    return this.countries.length > 2;
  }

  get isSingleDay(): boolean {
    return this.startDate.isSame(this.endDate, 'day');
  }
}
